export default __webpack_public_path__ + "static/media/area-66.db482b10.jpg";